// import { App } from 'vue';

import countdownPlugin from '@/plugins/countdownPlugin.js';

/**
 * 注册全局自定义方法
 * @param app
 */

export function setupGlobalMethods(app) {
    // 自定义方法
    app.use(countdownPlugin);

}